import { FC, useEffect, useState } from 'react'

import { RenderIf } from 'components/RenderIf'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'

import { ReactComponent as CrossSvg } from 'assets/circledCross.svg'
import checkmarkSvg from 'assets/payment/bigGreenCheckmark.svg'
import { ResultType } from './types'

import { IconFull } from 'components/IconsContainers/styled'
import {
  ButtonContainer,
  CrossContainer,
  ResultIcon,
  ResultIconContainer,
} from './styled'
import { useNavigate } from 'react-router-dom'
import { useOpenNoReceiptModal } from 'featureSliced/shared/hooks/openModals/useOpenNoReceiptModal'
import { Button } from 'featureSliced/entities/Button'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'

type ResultProps = {
  result: ResultType
  orderNr?: number
}

export const Result: FC<ResultProps> = ({ result, orderNr }) => {
  const t = useTranslations()
  const navigate = useNavigate()
  const openNoReceiptModal = useOpenNoReceiptModal()
  const backgroundColor = useMySelector(
    (state) => state.app.interfaceStyles.MainBackGround
  )

  const [renderRetry, setRenderRetry] = useState<boolean>()

  useEffect(() => {
    let timer: any
    if (orderNr) {
      timer = setTimeout(() => {
        handleResult()
      }, 1500)
    }

    return () => clearTimeout(timer)
  }, [])

  const handleResult = () => {
    if (result === 'success' && orderNr) {
      navigate(`/`)
      openNoReceiptModal(`${orderNr}`)
    } else {
      setRenderRetry(true)
    }
  }

  const handleTryAgain = () => {
    // TODO: location.reload is temporary and fastest solution. get rid of it
    window.location.reload()
  }

  return (
    <>
      <RenderIf condition={result === 'success'}>
        <ResultIconContainer>
          <ResultIcon src={checkmarkSvg} />
        </ResultIconContainer>
      </RenderIf>

      <RenderIf condition={result === 'fail'}>
        <ResultIconContainer>
          <CrossContainer>
            <IconFull fill="red" stroke={backgroundColor}>
              <CrossSvg />
            </IconFull>
          </CrossContainer>
        </ResultIconContainer>
      </RenderIf>

      <RenderIf condition={!!renderRetry}>
        <ButtonContainer>
          <Button buttonType="common" width="80vw" onClick={handleTryAgain}>
            {t('buttons.tryAgain')}
          </Button>
        </ButtonContainer>
      </RenderIf>
    </>
  )
}
